//import { BrowserAuthOptions, BrowserSystemOptions } from '@azure/msal-browser/dist/src/config/Configuration';
import { BrowserAuthOptions, BrowserSystemOptions } from "@azure/msal-browser/dist/config/Configuration";

// console.log( `NODE_ENV: ${process.env.NODE_ENV}`);
// console.log( `PUBLIC_URL: ${process.env.PUBLIC_URL}`);

export interface Config {
    auth: BrowserAuthOptions & {
        defaultScopes: string[];
    };
    system?: BrowserSystemOptions;
    api: {
        baseUrl: string;
        endpoints: {
            file: string;
            entity: string;
            event: string;
        };
        cache: string;
        filters: string;
    };
    viewer: {
        streamingUrl: string;
        restUrl: string;
    };
    org : string,
    website: string
}

const def_config: Config = {
    api: {
        baseUrl: "http://localhost/",
        endpoints: {
            file: "file.ashx",
            entity: "entity.ashx",
            event: "events.ashx",
        },
        cache: "false",
        filters: "false",
    },
    viewer: {
        streamingUrl: "ws://localhost:3333",
        restUrl: "http://localhost/",
    },
    auth: {
        clientId: "",
        authority: "",
        redirectUri: "",
        defaultScopes: [],
    },
    org : '2343243456678890',
    website : 'https://voxelspace.com'
};

export let config: Config;

export const loadConfig = async () => {
    const env = process.env.NODE_ENV;
    const path = process.env.PUBLIC_URL;

    //const envJSON = !env || env === "development" ? `${path}/env.dev.json` : `${path}/env.json`;
    const envJSON = !env || env === "development" ? `${path}/env.dev.json` : `${path}/env.staging.json`;

    let requestOptions: RequestInit = {
        method: "GET",
        redirect: "follow",
    };

    let response = await fetch(envJSON, requestOptions);
    console.log(response);
    let jsCfg = await response.json();

    console.log(jsCfg);
    config = Object.assign(def_config, jsCfg);
    return config;
};
